var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgSiftSpaceIcon = function SvgSiftSpaceIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 584 584",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M138.03 443.217v-20.359l68.775-68.773 20.504 20.358-68.891 68.774H138.03Zm0-40.862v-20.387l52.588-52.588c1.312 5.046 3.47 9.684 6.504 14.03l-59.092 58.945Zm61.25 40.862h-20.358l58.946-59.091c4.345 3.034 9.1 5.221 14 6.504l-52.588 52.587Z",
    style: {
      fill: "#e11010"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.354 159.922s30.625 71.517-51.157 153.271c-31.646 31.646-66.004 51.012-96.95 62.854-10.821 4.054-22.663 1.429-30.625-6.65l-30.771-30.625c-7.934-8.079-10.675-19.921-6.621-30.771 12.279-30.479 31.18-65.304 62.825-96.95 81.783-81.754 153.299-51.129 153.299-51.129ZM319.213 262.064c11.259 11.258 29.605 11.258 40.863 0 11.287-11.259 11.142-29.604 0-40.892-11.258-11.258-29.604-11.258-40.863 0-11.287 11.288-11.287 29.633 0 40.892Zm-128.596 43.925-55.329-23.567 88.142-40.017c-13.154 19.659-24.412 40.892-32.813 63.584Zm108.209 139.969-23.538-55.328c22.663-8.37 43.925-19.629 63.555-32.783l-40.017 88.111Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.667 550C434.342 550 550 434.342 550 291.667c0-142.674-115.658-258.334-258.333-258.334-142.674 0-258.334 115.66-258.334 258.334C33.333 434.342 148.993 550 291.667 550Zm0 33.333c161.083 0 291.666-130.583 291.666-291.666S452.75 0 291.667 0 0 130.584 0 291.667C0 452.75 130.584 583.333 291.667 583.333Z",
    style: {
      fill: "#f2f2f2"
    }
  }));
};
export default SvgSiftSpaceIcon;